import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import buttonImage from '../buttonimage.jpg';

const FIELD_CONFIG = [
  { key: 'sun', label: 'Sun' },
  { key: 'moon', label: 'Moon' },
  { key: 'ascendant', label: 'Ascendant' },
  { key: 'venus', label: 'Venus' },
  { key: 'mercury', label: 'Mercury' },
  { key: 'mars', label: 'Mars' },
  { key: 'north_node', label: 'North Node' },
  { key: 'mideheaven', label: 'Mideheaven' },
];

function AstrologyFields({ worksheetData }) {
  const [fields, setFields] = useState({});
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  // Always update fields when worksheetData changes
  useEffect(() => {
    const initial = {};
    FIELD_CONFIG.forEach(({ key }) => {
      initial[key] = worksheetData?.[key] || '';
    });
    setFields(initial);
  }, [worksheetData]); // <-- Use only worksheetData as dependency

  const handleChange = (key, value) => {
    if (value.length <= 15) {
      setFields((prev) => ({ ...prev, [key]: value }));
    }
  };

  const handleSave = async () => {
    setSaving(true);
    setMessage('');
    try {
      const { data: { user }, error: userError } = await supabase.auth.getUser();
      if (userError || !user) {
        setMessage('User not logged in!');
        setSaving(false);
        return;
      }
      const updateObj = { ...fields };
      const { error } = await supabase
        .schema('api')
        .from('worksheets')
        .upsert({ id: user.id, ...updateObj }, { onConflict: ['id'] });
      if (error) {
        setMessage('Failed to save: ' + error.message);
      } else {
        setMessage('Saved!');
      }
    } catch (err) {
      setMessage('Unexpected error: ' + err.message);
    }
    setSaving(false);
  };

  return (
    <div style={{ width: '100%', marginBottom: 4, paddingLeft: 0 }}>
      <style>{`
        @media (max-width: 600px) {
          .astro-fields-row { flex-direction: column !important; align-items: flex-start !important; }
          .astro-field-label { display: block !important; margin-bottom: 0 !important; }
          .astro-field-input { display: inline-block !important; width: 12ch !important; min-width: 12ch !important; max-width: 12ch !important; }
        }
        @media (min-width: 601px) {
          .astro-fields-row { flex-direction: column !important; align-items: flex-start !important; }
          .astro-field-label { display: block !important; margin-bottom: 0 !important; }
          .astro-field-input { display: inline-block !important; width: 12ch !important; min-width: 12ch !important; max-width: 12ch !important; }
        }
      `}</style>
      {Array.from({ length: 2 }).map((_, row) => (
        <div
          className="astro-fields-row"
          key={row}
          style={{
            display: 'flex',
            flexDirection: 'column', // Default: stack one per line
            gap: 0,
            width: '100%',
            justifyContent: 'flex-start',
            marginBottom: row === 0 ? 2 : 0,
            paddingLeft: 0,
          }}
        >
          {FIELD_CONFIG.slice(row * 4, row * 4 + 4).map(({ key, label }) => (
            <div key={key} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', minWidth: 0, flex: 'none', marginLeft: 0, paddingLeft: 0, marginBottom: 2 }}>
              <label className="astro-field-label" style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'normal', marginRight: 4, fontSize: 15, textAlign: 'left', whiteSpace: 'nowrap' }}>{label}:</label>
              <input
                className="astro-field-input"
                type="text"
                value={fields[key] || ''}
                maxLength={15}
                onChange={e => handleChange(key, e.target.value)}
                style={{
                  width: '12ch',
                  maxWidth: '12ch',
                  minWidth: '12ch',
                  border: '1px solid #ccc',
                  borderRadius: 4,
                  padding: '1px 2px',
                  fontFamily: 'Times New Roman, Times, serif',
                  fontSize: 15,
                  fontWeight: 'bold',
                  marginLeft: 0,
                  marginRight: 0,
                }}
              />
            </div>
          ))}
        </div>
      ))}
      <div style={{ textAlign: 'center', marginTop: 8 }}>
        <button
          onClick={handleSave}
          disabled={saving}
          style={{
            backgroundImage: `url(${buttonImage})`,
            backgroundSize: 'cover',
            border: 'none', // Remove black outline
            borderRadius: '6px',
            padding: '0 12px',
            width: 'auto',
            minWidth: 40,
            fontFamily: 'Times New Roman, Times, serif',
            fontSize: '13px',
            fontWeight: 'bold',
            boxShadow: '2px 2px 8px rgba(0,0,0,0.25)', // Add shadow
            cursor: saving ? 'not-allowed' : 'pointer',
            margin: '0 auto',
            display: 'inline-block',
            lineHeight: 1.1,
            height: 'auto',
            minHeight: 0,
          }}
        >
          {saving ? 'Saving...' : 'Save'}
        </button>
        {message && <div style={{ fontSize: 12, color: message === 'Saved!' ? 'green' : 'red', marginTop: 2 }}>{message}</div>}
      </div>
    </div>
  );
}

export default AstrologyFields;
